import axios from '../utils/axios';

export default function updateManagedRecruiterStatus(adminId, data) {
    return axios.post(`/admin/${adminId}/update-manager-status`, data);
};
